/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { EConstructorReportsNew } from '@pages/PageReportsConstructor/constants';

import { WizardReportConstructorStepStyled } from '../../components/styled/WizardReportConstructorStyled';
import WizardColumnsSelection from '../../components/WizardColumnsSelection';
import { mockReportColumns } from '../../mock';
import { IWizardOrderTemplateLocationData } from '../types';

interface IWizardOrderTemplateSelectionDataStep {
    templateData: IWizardOrderTemplateLocationData;
}

const WizardOrderTemplateSelectionDataStep: FC<IWizardOrderTemplateSelectionDataStep> = ({ templateData }) => {
    const { template } = templateData;

    return (
        <WizardReportConstructorStepStyled>
            {template.reportType === EConstructorReportsNew.REPORT_CUSTOM_SUBSCRIBERS && (
                <WizardColumnsSelection reportColumns={mockReportColumns} title="Столбцы в файле отчета" />
            )}
        </WizardReportConstructorStepStyled>
    );
};

export default WizardOrderTemplateSelectionDataStep;
